module.exports = __webpack_public_path__ + "img/advertisement_quanbg.b9c70e4a.png";